// icon:plus-circled | Entypo http://entypo.com/ | Daniel Bruce
import * as React from "react";

function IconPlusCircled(props) {
  return (
    <svg
      viewBox="0 0 840 1000"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M420 80c116 0 215 41 297 123s123 181 123 297-41 215-123 297-181 123-297 123-215-41-297-123S0 616 0 500s41-215 123-297S304 80 420 80m52 470h200V448H472V246H370v202H168v102h202v202h102V550" />
    </svg>
  );
}

export default IconPlusCircled;
